/** True when a document type/category row is referenced by live documents. */
export function isDocumentMasterRowUsed(row) {
  const value = row?.IsUsed ?? row?.isUsed;
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }
  return false;
}

export const QMS_DOCUMENT_TYPE_IN_USE_MESSAGE =
  "This document type is in use and cannot be edited.";

export const QMS_DOCUMENT_CATEGORY_IN_USE_MESSAGE =
  "This document category is in use and cannot be edited.";

export const EISF_DOCUMENT_TYPE_IN_USE_MESSAGE =
  "This document type is in use and cannot be edited.";

export const EISF_DOCUMENT_CATEGORY_IN_USE_MESSAGE =
  "This document category is in use and cannot be edited.";
